import { render, staticRenderFns } from "./MyMessage.vue?vue&type=template&id=1192a122&"
import script from "./MyMessage.vue?vue&type=script&lang=js&"
export * from "./MyMessage.vue?vue&type=script&lang=js&"
import style0 from "./MyMessage.vue?vue&type=style&index=0&id=1192a122&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports